import { type ForwardedRef, forwardRef,type HTMLProps } from 'react';
import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import { customScrollbar } from '@/styles/style';

const ScrollView = (
  props: HTMLProps<HTMLDivElement>,
  ref?: ForwardedRef<HTMLDivElement>,
) => {
  const {
    width = undefined,
    height = undefined,
    maxHeight = undefined,
    minHeight = undefined,
    ...rest
  } = props.style || {};

  return (
    <Style
      style={{ width, height, maxHeight, minHeight }}
      id={props.id}
      ref={ref}
    >
      <VFlex
        style={{
          ...rest,
          width: '100%',
          height: 'fit-content',
          minHeight: '100%',
        }}
      >
        {props.children}
      </VFlex>
    </Style>
  );
};

const Style = styled(Flex).attrs({
  d: 'column',
})`
  width: 100%;
  position: relative;
  overflow: auto;
  height: 100%;
  scroll-behavior: smooth;
  ${customScrollbar};
`;

export default forwardRef(ScrollView);
